const HOME: string = 'bh_benefits_home';
const COMPANY_HOME: string = 'bh_benefits_company_home';
const SIGNUP: string = 'bh_benefits_signup';
const YA_SIGNUP: string = 'bh_benefits_ya_signup';
const UPGRADE: string = 'bh_benefits_upgrade';
const VERIFY: string = 'bh_benefits_verify';

export default {
  HOME,
  COMPANY_HOME,
  SIGNUP,
  YA_SIGNUP,
  UPGRADE,
  VERIFY,
};
